import React from 'react';
import { useDispatch } from 'react-redux';
import PsDropdown from '../UI/PsDropdown';
import * as modalTypes from '../Modals/modalTypes';
import * as actions from '../../store/actions/index';
import { useHistory } from "react-router-dom";
import useCustomTranslation from '../../hooks/useCustomTranslation';

const ProjectCard = (props) => {

  const dispatch = useDispatch();
  const ct = useCustomTranslation();
  let history = useHistory();

  const showPdfModalHandler = () => {
    dispatch(actions.downloadProjectPdf(props.projectId, props.title));
  }

  const showDeleteProjectModalHandler = () => {
    const modalProps = {open: true, projectId: props.projectId};
    const modalType = modalTypes.MODAL_DELETE_PROJECT;
    dispatch(actions.showModal({ modalProps, modalType }));
  }

  const showCloneProjectModalHandler = () => {
    const modalProps = {open: true, formObject: {id: props.projectId}};
    const modalType = modalTypes.MODAL_CLONE_PROJECT;
    dispatch(actions.showModal({ modalProps, modalType }));
  }

  const showToggleActivateProjectModalHandler = () => {
    let modalType = (props.archived === true)? modalTypes.MODAL_REACTIVATE_PROJECT : modalTypes.MODAL_DEACTIVATE_PROJECT
    const modalProps = {open: true, projectId: props.projectId};
    dispatch(actions.showModal({ modalProps, modalType }));
  }

  const titleToggleArchive = (props.archived === true)? ct('projectcard.dropdown.reactivate_project') : ct('projectcard.dropdown.archive_project')

  const dropDownItems = () => {
     let options = [];
      options.push({action: showPdfModalHandler, text: ct('projectcard.dropdown.create_project_pdf'), id: props.projectId + "pdf"});
      if (props.archived === false) { options.push({action: showCloneProjectModalHandler, text: ct('projectcard.dropdown.copy_project'), id: props.projectId + "clone" })};
      options.push({action: showToggleActivateProjectModalHandler, text: titleToggleArchive, id: props.projectId + "togglestatus"});
      if (props.role === "owner") { options.push({action: showDeleteProjectModalHandler, text: ct('projectcard.dropdown.delete_project'), id: props.projectId + "delete" })};
      return options;
  }

  const onProjectSelect = () => {
    history.push(props.linkTo);
  }

  return (
    <div className="card card-task" onClick={onProjectSelect}>
       <div className="card-body projects">
          <div className="card-title">
             <a>
                <h6 data-filter-by="text">{props.title}</h6>
                <span className="text-small">{props.subtitle}</span>
             </a>
          </div>
          <div className="card-meta">
             <div className="d-flex align-items-center" onClick={onProjectSelect}>
                <button className="btn btn-round" style={{margin: "0px 12px 0px 12px", paddingLeft: "4px", background: "white"}}>
                <i className="material-icons">edit</i>
                </button>
             </div>
             { (props.role === "guest")?

               <div className="d-flex align-items-center">
                  <i className="material-icons invited">person</i>
               </div>

               : null
             }


             <div>&nbsp;&nbsp;</div>
             <div className="d-flex align-items-center">
                <i className="material-icons">menu_open</i>
                <span>{props.countProjectunits}</span>
             </div>

             <div className="dropdown card-options" >
               <PsDropdown items={dropDownItems()} />
             </div>
          </div>
       </div>
    </div>


  )
}

export default ProjectCard;



// WEBPACK FOOTER //
// ./src/components/Projects/ProjectCard.js